import { createFileRoute } from '@tanstack/react-router'

import PendingComponent from '@/components/pending-component'
import { actionReadingQuery } from '@/queries/action-reading.query'

export const Route = createFileRoute('/_dashboard/site/$id/my-actions/$actionId/')({
  loader({ params, context: { queryClient } }) {
    return queryClient.ensureQueryData(actionReadingQuery(params.id, params.actionId))
  },
  pendingComponent: PendingComponent,
})
